import { atom } from 'recoil';

import { WorkPatternResponse } from 'RestAPIs/work-patterns';

const uniqueAtomKey = 'WorkPattern_';

export const isEditModeState = atom({
  key: `${uniqueAtomKey}isEditMode`,
  default: false
});

export const hasChangesState = atom({
  key: `${uniqueAtomKey}hasChanges`,
  default: false
});

export const workPatternsState = atom<WorkPatternResponse[]>({
  key: `${uniqueAtomKey}workPatterns`,
  default: []
});

export const isEmployeePortalState = atom<boolean>({
  key: `${uniqueAtomKey}isEmployeePortal`,
  default: false
});
